import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { StructureOrganizativeService } from '../../services/structure-organizative.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'mapfre-auditlib-select-organizational-structure',
  templateUrl: './select-organizational-structure.component.html',
  styleUrls: ['./select-organizational-structure.component.scss']
})
export class SelectOrganizationalStructureComponent implements OnInit {

  constructor(private authService: AuthService, private structureOrganizativeService: StructureOrganizativeService) { }
  mainStructureOrganizative;
  structureOrganizative;

  @Input() form: UntypedFormGroup;
  @Input() label;
  ngOnInit() {
    this.mainStructureOrganizative = this.authService.getUserMainSO()[0];
    this.structureOrganizativeService.getAllSO().subscribe((structureOrganizative) => {
      this.structureOrganizative = structureOrganizative;
      this.getStructuresOrderedBySelection();

    });
  }


  //keep main structure organizative
  keepData(event) {
    if (this.mainStructureOrganizative) {
      const existsIn = _.some(event.value, (os) => {
        return _.isEqual(os.idOrganizationalStructurePk, this.mainStructureOrganizative.idOrganizationalStructurePk);
      });
      if (!existsIn) {
        event.value.unshift(this.mainStructureOrganizative);
        this.form.setValue(event.value);
      }
    }
  }

  isOptionSelected(item) {
    let option = item.value;
    let optionsSelected = this.form.value;
    return _.some(optionsSelected, (o) => {
      return _.isEqual(o.idOrganizationalStructurePk, option.idOrganizationalStructurePk);
    });
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  onRemoveSelectedItem(event, item) {
    event.stopPropagation();
    let selectedItems = this.form.value;
    if (_.isArray(selectedItems) && _.get(item, "idOrganizationalStructurePk") != _.get(this.mainStructureOrganizative, 'idOrganizationalStructurePk')) {
      _.remove(selectedItems, (i: any) => i.idOrganizationalStructurePk === item.idOrganizationalStructurePk);
    }
    this.form.setValue(selectedItems);
  }

  setWeight(item, value) {
    if (value !== undefined) {
      item.value.hours = value;
      const id = _.findIndex(this.form.value, (i: any) => i.idOrganizationalStructurePk === item.value.idOrganizationalStructurePk);
      _.set(_.get(this.form.value, id), 'hours', value);
      this.form.updateValueAndValidity();
    }
  }

  getStructuresOrderedBySelection() {
    let ids = _.map(this.form.value, (so) => _.get(so, 'idOrganizationalStructurePk'));
    const os = _.orderBy(this.structureOrganizative, (so) => {
      return _.find(ids, (id) => {
        if (id === _.get(so, "idOrganizationalStructurePk")) {
          so.hours = _.get(_.find(this.form.value, item => item.idOrganizationalStructurePk === id), 'hours');
          return true;
        }
        return false;
      });
    });
    this.structureOrganizative = os;
  }

  onHideHandler() {
    this.getStructuresOrderedBySelection();
  }

}
